export const jobConstants = {
    Months : [ 'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
    
    JOBS_GET_BY_SITE_AND_YEAR_REQUEST: 'JOBS_GET_BY_SITE_AND_YEAR_REQUEST',
    JOBS_GET_BY_SITE_AND_YEAR_SUCCESS: 'JOBS_GET_BY_SITE_AND_YEAR_SUCCESS',
    JOBS_GET_BY_SITE_AND_YEAR_FAILURE: 'JOBS_GET_BY_SITE_AND_YEAR_FAILURE'
};